<template>
  <div>
    <el-dialog
      title="登记"
      width="72%"
      :visible.sync="formVisible"
      @close="closeDialog"
      v-alterELDialogMarginTop="{marginTop:'4vh'}"
    >
      <el-dialog
        class="other-dialog-dialog"
        width="30%"
        title="拒绝原因"
        :visible.sync="tableRowData.rejectVisible"
        append-to-body
      >
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableRowData.rejectReason"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="tableRowData.rejectVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="postTo(false)">提交</el-button>
        </div>
      </el-dialog>
      <el-dialog
        class="other-dialog-dialog"
        width="30%"
        title="暂押物品归还情况"
        :visible.sync="tableRowData.backVisible"
        append-to-body
      >
        <span style="margin-left:20px;margin-top:20px;">归还情况:</span>
        <el-radio v-model="tableRowData.pledgeGiveBack" label="0">无押物</el-radio>
        <el-radio v-model="tableRowData.pledgeGiveBack" label="1">未归还</el-radio>
        <el-radio v-model="tableRowData.pledgeGiveBack" label="2">已归还</el-radio>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="tableRowData.backVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="postOut()">提交</el-button>
        </div>
      </el-dialog>

      <div class="other-detail-div">
        <div class="table-div">
          <table style="width:95%">
            <caption style="font-size:28px;margin-bottom:10px;">
              访客登记单
              (
              <span>
                {{
                tableRowData.row.state===1?"待批准":
                tableRowData.row.state===2?"待访问":
                tableRowData.row.state===3?"待离开":
                tableRowData.row.state===4?"已变更":
                tableRowData.row.state===5?"已取消":
                tableRowData.row.state===6?"已结束":
                tableRowData.row.state===7?"已拒绝":
                tableRowData.row.state===10?"已访问":'状态异常'
                }}
              </span>)
              <span style="float:right">
                <!-- 准入 -->
                <el-button
                  type="primary"
                  v-if="showAllToButtom===true&&(tableRowData.row.state===1||tableRowData.row.state===2)"
                  size="mini"
                  @click="postTrue()"
                >全部放行</el-button>
                <el-button
                  type="danger"
                  v-if="showAllFalseButtom===true&&(tableRowData.row.state===1||tableRowData.row.state===2)"
                  size="mini"
                  @click="postFalse()"
                >全部拒绝</el-button>
                <!-- 准出 -->
                <el-button
                  type="primary"
                  v-if="showAllOutButtom===true&&(tableRowData.row.state===3||tableRowData.row.state===10)"
                  size="mini"
                  @click="tableRowData.backVisible=true"
                >全部放出</el-button>
              </span>
            </caption>
            <tr>
              <th style="width:100px;">来访企业</th>
              <td colspan="3">{{tableRowData.row.visitorCompanyName}}</td>
              <th style="width:100px;">来自区域</th>
              <td style="width:100px;">{{tableRowData.row.visitorProvinceCode}}</td>
              <th style="width:100px;">来访人数</th>
              <td style="width:100px;">{{tableRowData.row.actualPeopleCount}}</td>
            </tr>
            <tr>
              <th>拜访事由</th>
              <td colspan="7">{{tableRowData.row.reason}}</td>
            </tr>
            <tr>
              <th>备注</th>
              <td colspan="7">{{tableRowData.row.remark}}</td>
            </tr>
            <tr>
              <th>预约拜访时间</th>
              <td>{{tableRowData.row.reservationDate}}</td>
              <th style="width:80px;">进入时间</th>
              <td style="width:120px;">{{tableRowData.operatorTime}}</td>
              <th>值班登记人</th>
              <td colspan="3">{{tableRowData.operatorName}}</td>
            </tr>
            <tr>
              <th>受访部门</th>
              <td>{{tableRowData.row.targetDepartmentName}}</td>
              <th>受访人</th>
              <td>{{tableRowData.row.targetUserName}}</td>
              <th>固定电话</th>
              <td>{{tableRowData.row.phone}}</td>
              <th>手机</th>
              <td>{{tableRowData.row.mobile}}</td>
            </tr>
          </table>
        </div>
        <div class="form-div">
          <span>暂押物品</span>
          <el-divider></el-divider>
          <el-radio
            :disabled="!(tableRowData.row.state===1||tableRowData.row.state===2)"
            v-model="tableRowData.radio"
            label="0"
          >身份证</el-radio>
          <el-radio
            :disabled="!(tableRowData.row.state===1||tableRowData.row.state===2)"
            v-model="tableRowData.radio"
            label="1"
          >人民币</el-radio>
          <el-radio
            :disabled="!(tableRowData.row.state===1||tableRowData.row.state===2)"
            v-model="tableRowData.radio"
            label="2"
          >其他</el-radio>
          <div>
            <el-input
              size="mini"
              style="width:100%;"
              type="textarea"
              :rows="2"
              :disabled="!(tableRowData.row.state===1||tableRowData.row.state===2)"
              v-model="tableRowData.pledgeContent"
              placeholder="备注"
            ></el-input>
          </div>
        </div>
        <div class="form-div">
          <span>来访人员详情</span>
          <el-divider></el-divider>
          <el-row>
            <el-col style="width:50%;">
              <el-card style="margin:10px ">
                <a style="cursor:pointer;" @click="showCard1()">
                  <table class="card-table" style="width:100%">
                    <tr>
                      <td style="width:130px">
                        <img
                          v-if="tableRowData.user.photoPath!=''"
                          :src="imgUrl+tableRowData.user.photoPath"
                        />
                        <img v-else-if="tableRowData.user.sex===0" src="@/assets/tx1.jpg" />
                        <img v-else src="@/assets/tx4.jpg" />
                      </td>
                      <td class="man-info">
                        <div>
                          姓名：{{tableRowData.user.name}}
                          <template
                            v-if="tableRowData.user.realNameState===1"
                          >
                            <div class="real-state1">实名认证</div>
                          </template>
                          <template v-if="tableRowData.user.realNameState===0">
                            <div class="real-state2">未认证</div>
                          </template>
                        </div>
                        <div>性别：{{tableRowData.user.sex===1?'男':'女'}}</div>
                        <div>电话：{{tableRowData.user.mobile}}</div>
                        <div>公司：{{tableRowData.user.tempCompanyName}}</div>
                        <div>身份证：{{tableRowData.user.idCardNumber|filterCard}}</div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" style="height:1px;">
                        <el-divider></el-divider>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: right;vertical-align: top;" colspan="2">
                        <template v-if="tableRowData.user.UnLeaveRegisterCount!=null">
                          <span
                            style="float:left;"
                          >备注：之前内正常办理离开登记{{tableRowData.user.UnLeaveRegisterCount}}次</span>
                          <span style="clear:both;"></span>
                        </template>
                        <el-button
                          type="success"
                          v-if="tableRowData.user.reject==='1'"
                          size="mini"
                          class="button"
                        >已准入</el-button>
                        <el-button
                          type="info"
                           v-else-if="tableRowData.user.reject==='0'"
                          size="mini"
                          class="button"
                        >已禁入</el-button>
                        <el-button
                          type="danger"
                         v-else
                          size="mini"
                          class="button"
                        >未准入</el-button>
                        
                        <template v-if="tableRowData.row.state>2">
                          <el-button
                            type="success"
                            v-if="tableRowData.user.leave==='1'"
                            size="mini"
                            class="button"
                          >已准出</el-button>
                          <el-button
                            type="danger"
                            v-else-if="tableRowData.user.leave===undefined||tableRowData.user.leave===''"
                            size="mini"
                            class="button"
                          >未准出</el-button>
                        </template>
                      </td>
                    </tr>
                  </table>
                </a>
              </el-card>
            </el-col>
            <el-col v-for="(model,index) in tableRowData.userDto" :key="index" style="width:50%;">
              <el-card style="margin:10px">
                <a class="card-a" style="cursor:pointer;" @click="showCard2(index)">
                  <table class="card-table" style="width:100%">
                    <tr>
                      <td style="width:130px">
                        <img v-if="model.photoPath!=''" :src="imgUrl+model.photoPath" />
                        <img v-else-if="model.sex===0" src="@/assets/tx1.jpg" />
                        <img v-else src="@/assets/tx4.jpg" />
                      </td>
                      <td class="man-info">
                        <div>
                          姓名：{{model.name}}
                          <template v-if="model.realNameState===1">
                            <div class="real-state1">实名认证</div>
                          </template>
                          <template v-if="model.realNameState===0">
                            <div class="real-state2">未认证</div>
                          </template>
                        </div>
                        <div>性别：{{model.sex===1?'男':'女'}}</div>
                        <div>电话：{{model.mobile}}</div>
                        <div>公司：{{model.visitorCompanyName}}</div>
                        <div>身份证：{{model.idCardNumber|filterCard}}</div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" style="height:1px;">
                        <el-divider></el-divider>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: left;vertical-align: top;">
                        <span></span>
                      </td>
                      <td style="text-align: right;vertical-align: top;">
                        <el-button
                          type="success"
                          v-if="model.reject==='1'"
                          size="mini"
                          class="button"
                        >已准入</el-button>
                        <el-button
                          type="info"
                           v-else-if="model.reject==='0'"
                          size="mini"
                          class="button"
                        >已禁入</el-button>
                        <el-button
                          type="danger"
                          v-else
                          size="mini"
                          class="button"
                        >未准入</el-button>
                        <template v-if="tableRowData.row.state>2">
                          <el-button
                            type="success"
                            v-if="model.leave==='1'"
                            size="mini"
                            class="button"
                          >已准出</el-button>
                          <el-button
                            type="danger"
                             v-else-if="model.leave===undefined||model.leave===''"
                            size="mini"
                            class="button"
                          >未准出</el-button>
                        </template>
                      </td>
                    </tr>
                  </table>
                </a>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetReservationDtoById,
  getReservationRecord, //获取进入时间和值班登记人
  getReservationUserDto, //获取来访人
  getReservationCompanies, //获取随行人员
  saveAccessInfo, //准入登记(拒绝)
  saveLeaveInfo, //准出登记
  getCompaniesInfo, //获取人员信息
  imgUrl, //图片路径
  userAuthentication
} from "@/api/api";
import $ from "jquery"; //在需要使用的页面中

export default {
  data() {
    return {
      user: JSON.parse(window.localStorage.user),
      formVisible: false, //预约弹出框
      tableRowData: {}, //预约弹出框对象
      imgUrl: imgUrl,
      showAllToButtom: true, //显示全部放行
      showAllFalseButtom: true, //显示全部拒绝
      showAllOutButtom: true //显示全部放出
    };
  },
  //超过8个字符隐藏后面的
  filters: {
    filterCard(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.replace(/^(.{4})(?:\d+)(.{4})$/, "$1******$2");
      }
      return value;
    }
  },
  methods: {
    loadPara() {
      this.tableRowData = {
        radio: "0",
        pledgeContent: "", //暂扣物件其他
        rejectVisible: false, //显示拒绝理由弹出框
        rejectReason: "", //拒绝原因
        backVisible: false, //显示归还情况弹出框
        pledgeGiveBack: "0", //归还情况 GiveBack无暂押物 None=0未归还 No=1已归还 Yes=2
        row: {}, //行对象
        user: {}, //来访人员
        userDto: [], //随行人员集合
      }; //预约弹出框对象
      this.showAllToButtom= true; //显示全部放行
      this.showAllFalseButtom= true; //显示全部拒绝
      this.showAllOutButtom= true; //显示全部放出
    },
    //草稿 Draft=0 (拜访人保存状态)
    //待批准 WaitApprove=1 (门卫和受访人可查询到该记录，门卫和受访人均可提交，门卫提交后到达待访问2和7，
    //受访人通过到达2，变更和取消到达4和5的状态)
    //待访问 WaitVisit=2 (门卫可查询到该记录，提交后到达3)
    //待离开 WaitLeave=3 (受访人可查询该记录，提交后到达已访问10)
    //已访问 Meeted=10 (门卫可查询到该记录，提交后到达已结束6)
    //已结束 Finished=6（放行，访问结束）
    //已变更 Changed=4
    //已取消 Cancelled=5
    //已拒绝 Reject=7
    oper(rId) {
      this.loadPara();
      var row = {};
      var _this = this;
      //获取
      GetReservationDtoById({ params: { id: rId } }).then(res => {
        if (res.data.success) {
          row = res.data.data;
          var pledgeCategory = row.pledgeCategory;
          if (pledgeCategory === undefined) {
            _this.tableRowData.radio = "0";
          } else {
            _this.tableRowData.radio = row.pledgeCategory.toString();
          }
          _this.tableRowData.pledgeContent = row.pledgeContent;
          _this.tableRowData.row = row;

          //获取进入时间和值班登记人
          var para = {
            params: { reservationId: row.id, state: 3 }
          };
          getReservationRecord(para).then(res => {
            if (res.data.success) {
              try {
                if (res.data.data.length > 0) {
                  _this.tableRowData.operatorTime =
                    res.data.data[0].operatorTime;
                  _this.tableRowData.operatorName =
                    res.data.data[0].operatorName;
                }
              } catch (e) {}
              _this.formVisible = false;
              _this.formVisible = true;
            }
          });
          _this.getCheckUserInfo();
        }
      });
    },
    getCheckUserInfo() {
      var _this = this;
      var para = {
        params: { reservationId: this.tableRowData.row.id, state: 3 }
      };
      //获取来访人
      getReservationUserDto(para).then(res => {
        if (res.data.success) {
          _this.tableRowData.user = res.data.data;
          if (res.data.data.reject==='0'||res.data.data.reject === "1") {
            _this.showAllToButtom = false; //显示全部放行
            _this.showAllFalseButtom = false; //显示全部拒绝
          }
          // if (res.data.data.leave === '1') {
          //   _this.showAllOutButtom = false; //显示全部放出
          // }
          _this.formVisible = false;
          _this.formVisible = true;
        }
      });
      //获取随行人员
      getReservationCompanies(para).then(res => {
        if (res.data.success) {
          _this.tableRowData.userDto = res.data.data;
          if (res.data.data.length > 0) {
            res.data.data.forEach(element => {
               //alert(element.reject);
              if (element.reject==='0'||element.reject === "1") {
                _this.showAllToButtom = false; //显示全部放行
                _this.showAllFalseButtom = false; //显示全部拒绝
              }
              // if (element.leave === '1') {
              //   _this.showAllOutButtom = false; //显示全部放出
              // }
            });
          }

          _this.formVisible = false;
          _this.formVisible = true;
        }
      });
    },
    //显示健康卡信息
    showCard1() {
      //this.formVisible = false;
      this.$emit(
        "backFun",
        this.tableRowData.row.id,
        this.tableRowData.user.id
      );
    },
    showCard2(index) {
      //this.formVisible = false;
      this.$emit(
        "backFun",
        this.tableRowData.row.id,
        this.tableRowData.userDto[index].id
      );
    },
    //全部放进
    postTrue() {
      var _this = this;
      this.$confirm("是否确定准入操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _this.postTo(true);
        })
        .catch(() => {});
    },
    //全部拒绝
    postFalse() {
      this.tableRowData.rejectVisible = true;
      this.tableRowData.rejectReason = "";
    },

    //准入和拒绝提交
    postTo(type) {
      //var pledgeContent = ""; //暂押物品
      if (type === false) {
        if (this.tableRowData.rejectReason === "") {
          this.$message.error("请输入拒绝原因！");
          return;
        }
      }
      var para = {
        userId: this.user.id,
         isAccess: type, //放行或拒绝
        visitReject: type ===true?1:0, //已核实或未核实
        rejectReason: this.tableRowData.rejectReason, //拒绝原因
        reservationId: this.tableRowData.row.id, //主键Id
        pledgeCategory: parseInt(this.tableRowData.radio), //暂押物类型
        pledgeContent: this.tableRowData.pledgeContent, //暂押物品内容
        doorId: this.user.door.id,
        visitorList: [] //随行对象
      };

       
      this.tableRowData.userDto.forEach(mod => {
        var visitor = {};
        visitor.reservationId = this.tableRowData.row.id;
        visitor.userId = mod.id;
        visitor.reject = type ===true?1:0;
        para.visitorList.push(visitor);
      });
      var _this = this;
      saveAccessInfo(para).then(res => {
        if (res.data.success) {
          _this.$emit("loadData");
          _this.formVisible = false;
          _this.tableRowData.rejectVisible = false;
          window.sessionStorage.isLoadParaPage="true";
          _this.$message.success("提交成功！");
        } else {
          _this.$message.error("提交失败！");
        }
      });
    },
    //全部准出
    postOut() {
      this.$confirm("是否确定准出操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var para = {
            userId: this.user.id,
            reservationId: this.tableRowData.row.id,
            pledgeGiveBack: this.tableRowData.pledgeGiveBack === "0" ? 0 : 1 //归还情况  None=0未归还 No=1已归还 Yes=2
          };

          var _this = this;
          saveLeaveInfo(para).then(res => {
            if (res.data.success) {
              _this.$emit("loadData");
              _this.formVisible = false;
              _this.tableRowData.backVisible = false;
              window.sessionStorage.isLoadParaPage="true";
              _this.$message.success("提交成功！");
            } else {
              _this.$message.error("提交失败！");
            }
          });
        })
        .catch(() => {});
    },
    closeDialog() {
      window.localStorage.removeItem("rid");
       if (window.sessionStorage.isLoadParaPage) {  //isLoadParaPage是否刷新父页面
       window.sessionStorage.removeItem('isLoadParaPage');
         window.location.reload();

       }
    }
  }
};
</script>

<style scoped>
a:hover > table {
  background-color: #eee; /*鼠标在a上面时，span变蓝色*/
}
img {
  border: 0;
  margin: 0;
  padding: 0;
  max-width: 600px;
  width: expression(this.width>560? "560px": this.width);
  max-height: 600px;
  height: expression(this.height>560? "560px": this.height);
}
</style>


// WEBPACK FOOTER //
// src/components/fksys/resCheck.vue